import {TAlbum, TTrack} from '../../../typings/todo';

export function getEntityFileId({album, track}: {album: TAlbum; track?: TTrack}) {
  if (track) {
    if (!track.wavFile) {
      throw new Error('Track is for purchase but has no url');
    }

    return track.wavFile.split('/').pop();
  }
  const albumUrl = album.albumUrl;
  if (!albumUrl) {
    throw new Error('Album is for purchase but has no url');
  }
  return albumUrl;
}
